"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsContact = _interopRequireDefault(require("../../styles/dealer-details-contact.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DealerPhone = function DealerPhone(_ref) {
  var phoneNumber = _ref.phoneNumber,
    theme = _ref.theme,
    clickHandler = _ref.clickHandler;
  if (!(0, _checkProps["default"])(phoneNumber)) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: _dealerDetailsContact["default"].dealerDetailLink + " " + _dealerDetailsContact["default"].phone + " " + (theme ? theme.smallType : ''),
      href: "tel:" + phoneNumber,
      onClick: function onClick() {
        return clickHandler && clickHandler(phoneNumber);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cpath id='a' fill='%23000' d='M3 3v6.414l2.293 2.293 7 7L14.586 21H21v-6h-4.235l-3.568 1.783-6.31-6.31L9 7.303V3H3zm2 5.586V5h2v1.697L5.444 9.03 5 8.586zm9.688 9.689L17.236 17H19v2h-3.586l-.726-.725z'/%3E%3C/defs%3E%3Cuse fill-rule='evenodd' xlink:href='%23a'/%3E%3C/svg%3E",
      alt: "phone icon",
      className: _dealerDetailsContact["default"].contactIcon
    }), phoneNumber);
  }
  return null;
};
var _default = DealerPhone;
exports["default"] = _default;